import { useEffect } from 'react';
import SharedHeader from '../../components/feature/SharedHeader';
import Footer from '../home/components/Footer';

export default function CookiePolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <SharedHeader />
      
      <main className="max-w-[900px] mx-auto px-6 lg:px-8 py-20">
        <h1 className="text-[42px] font-bold text-[#111111] mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>
          Cookie Policy
        </h1>
        
        <p className="text-[15px] text-[#666666] mb-12" style={{ fontFamily: 'Manrope, sans-serif' }}>
          This website may use cookies to enhance user experience.
        </p>

        {/* Section 1 */}
        <section className="mb-10">
          <h2 className="text-[24px] font-semibold text-[#111111] mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>
            1. What Are Cookies
          </h2>
          <p className="text-[15px] text-[#666666] leading-relaxed" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Cookies are small files stored on your device.
          </p>
        </section>

        {/* Section 2 */}
        <section className="mb-10">
          <h2 className="text-[24px] font-semibold text-[#111111] mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>
            2. Types of Cookies Used
          </h2>
          <ul className="list-disc pl-6 space-y-2">
            <li className="text-[15px] text-[#666666] leading-relaxed" style={{ fontFamily: 'Manrope, sans-serif' }}>
              <strong className="text-[#111111]">Essential cookies</strong> (site functionality)
            </li>
            <li className="text-[15px] text-[#666666] leading-relaxed" style={{ fontFamily: 'Manrope, sans-serif' }}>
              <strong className="text-[#111111]">Analytics cookies</strong> (anonymous traffic data)
            </li>
          </ul>
        </section>

        {/* Section 3 */}
        <section className="mb-10">
          <h2 className="text-[24px] font-semibold text-[#111111] mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>
            3. Managing Cookies
          </h2>
          <p className="text-[15px] text-[#666666] leading-relaxed" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Users may control cookie preferences via browser settings.
          </p>
        </section>

        {/* Section 4 */}
        <section className="mb-10">
          <h2 className="text-[24px] font-semibold text-[#111111] mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>
            4. Third-Party Cookies
          </h2>
          <p className="text-[15px] text-[#666666] leading-relaxed" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Analytics providers may place cookies for statistical purposes.
          </p>
        </section>

        {/* Section 5 */}
        <section className="mb-10">
          <h2 className="text-[24px] font-semibold text-[#111111] mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>
            5. Updates
          </h2>
          <p className="text-[15px] text-[#666666] leading-relaxed" style={{ fontFamily: 'Manrope, sans-serif' }}>
            We may update this Cookie Policy periodically.
          </p>
        </section>

        {/* Contact */}
        <div className="mt-16 pt-8 border-t border-gray-200">
          <p className="text-[15px] text-[#666666]" style={{ fontFamily: 'Manrope, sans-serif' }}>
            For questions about this Cookie Policy, please contact us at:{' '}
            <a 
              href="mailto:info@precious-leader-trade.com" 
              className="text-[#B11226] hover:underline"
            >
              info@precious-leader-trade.com
            </a>
          </p>
        </div>
      </main>

      <Footer />
    </div>
  );
}